import DirectFlightLabel from './DirectFlightLabel';

export default DirectFlightLabel;
